export default __webpack_public_path__ + "static/media/Events.cc5887e3.svg";